import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCoupons } from '../services/api'; // Use your API file

export const getCoupons = createAsyncThunk('coupons/getCoupons', async () => {
    const response = await fetchCoupons(); // Pass reviewId if available
    return response.data;
});

const couponSlice = createSlice({
    name: 'coupons',
    initialState: {
        coupons: [],  // Storing open calls here
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: {
        [getCoupons.pending]: (state) => {
            state.status = 'loading';
        },
        [getCoupons.fulfilled]: (state, action) => {
            state.coupons = action.payload.data;
            state.status = 'succeeded';
        },
        [getCoupons.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default couponSlice.reducer;